import React, { useState } from "react";
import styles from "./ProfessionalCardBottomPart.module.css";

const ProfessionalCardBottomPart = (props) => {
  const [showAll, setShowAll] = useState(false);
  const specializationList = props.specialization
    ? props.specialization.split(",").map((item) => item.trim())
    : [];

  const displayedSpecializations = showAll
    ? specializationList
    : specializationList.slice(0, 2);

  return (
    <div className={styles.skills}>
      <h2 className={styles.title}>Specialization</h2>
      <ul className={styles.skillList}>
        {displayedSpecializations.map((skill, index) => (
          <li key={index} className={styles.skillItem}>
            {skill}
          </li>
        ))}
      </ul>
      {specializationList.length > 2 && (
        <button
          className={styles.viewMoreButton}
          onClick={() => setShowAll(!showAll)}
        >
          {showAll ? "View Less" : "View More"}
        </button>
      )}
    </div>
  );
};

export default ProfessionalCardBottomPart;
